module.exports = __webpack_public_path__ + "static/media/bp4.5dda470d.jpg";